import { IonCol, IonRow } from "@ionic/react";
import React, { FC } from "react";
import AnnualEnergyTargetsTool from "./AnnualEnergyTargetComponents/AnnualEnergyTargetTool";
import AnnualEnergyTargetSavedData from "./AnnualEnergyTargetComponents/AnnualEnergyTargetSavedData";
import "./AnnualEnergyTarget.css";

interface IProps {
  building?: string | null;
}

const AnnualEnergyTargets: FC<IProps> = (props) => {
  const { building } = props;
  const [data, setData] = React.useState<any>(null);
  const [toolData, setToolData] = React.useState<any>(null);
  const [reload, setReload] = React.useState<boolean>(false);
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

  return (
    <IonRow>
      <IonCol size="12" sizeMd="12">
        <h2 className={newUI?'text-dark-blue':''}>Annual Energy Targets</h2>
      </IonCol>
      <IonCol size="12" sizeMd="3">
        <AnnualEnergyTargetSavedData
          building={building}
          data={data}
          setData={setData}
          setSelectedData={setToolData}
          reload={reload}
          setReload={setReload}
        />
      </IonCol>
      <IonCol size="12" sizeMd="9" style={{ marginBottom: "120px" }}>
        <AnnualEnergyTargetsTool
          building={building}
          data={toolData}
          setToolData={setToolData}
          setReload={setReload}
        />
      </IonCol>
    </IonRow>
  );
};

export default AnnualEnergyTargets;
